import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updateBrandLogo,getBrandLogoById } from "adminApi/BrandListApi/BrandList";
import { validateForm } from "utils/validation";
import { BrandLogoRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditBrandLogoForm from "./Componates/EditBrandLogoForm";
import fields from "../json/BrandLogoListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditBrandLogo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize default form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setValues, setErrors } = useFormChange(
    initialValues,
    BrandLogoRules
  );

  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    getBrandLogoById,
    setValues
  );

  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await updateBrandLogo({id,data:formData});
    },
    (vals) => {
      if (typeof (vals.brand_logo) === "string") {
        delete vals.brand_logo
      }
      delete vals.brand_logoPreview
      const err = validateForm(vals, BrandLogoRules)
      setErrors(err)
      return err
    },
    () => navigate(-1),
    "Brand Logo Updated successfully"
  );
  return (
    <>
      {(loading || loadingFetch) && <Spinner isSpinner={true} />}
      <EditBrandLogoForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={values.brand_logoPreview || values.brand_logo}
        loading={loading}
        title="Brand Logo"
      />
    </>
  );
};

export default EditBrandLogo;
